<template>
    <div v-if="levelList.length>1" class="d2-multiple-page-control-group" flex>
        <div class="d2-multiple-page-control-content" flex-box="1">
            <div class="d2-multiple-page-control-content-inner">
                <!--<el-breadcrumb separator-class="el-icon-arrow-right" style="background: #ffffff;padding: 10px 20px;margin-left: 1px;border-bottom: 1px solid #eaeaea;">
                  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                  <el-breadcrumb-item>活动管理</el-breadcrumb-item>
                  <el-breadcrumb-item>活动列表</el-breadcrumb-item>
                  <el-breadcrumb-item>活动详情</el-breadcrumb-item>
                </el-breadcrumb>-->
                <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
                    <!--<transition-group name="breadcrumb">-->
                    <el-breadcrumb-item v-for="(item,index)  in levelList" v-if="menuHeaderMap[item]" :key="index">
                        <!--<span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{item.meta.title}}</span>
                        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>-->
                        <router-link :to="item">{{menuHeaderMap[item].title}}</router-link>
                    </el-breadcrumb-item>
                    <!--</transition-group>-->
                </el-breadcrumb>
            </div>
        </div>

    </div>
</template>

<script>
    //import { mapState, mapMutations } from 'vuex'
    export default {
        name: 'ZebraBreadcrumb',
        components: {

        },
        props:{
            menuHeader: {
                type: Array,
                required: true
            },
            menuAside: {
                type: Array,
                required: true
            }
        },
        created() {
            this.menuHeaderMap = this.setMenuHeaderMap(this.menuAside)
            this.getBreadcrumb()
        },
        data () {
            return {
                levelList: null,
                menuHeaderMap: {},
                // 不显示面包屑的页面路径
                excludePath: [
                    '/index',
                    '/index/',
                    '/appstore-public/login',
                    '/appstore-public/register'
                ]
            }
        },
        /*computed: {
            ...mapState({
                menuHeader: state => state.d2admin.menuHeader,
                menuAside: state => state.d2admin.menuAside
            })
        },*/
        watch: {
            $route() {
                this.getBreadcrumb()
            },
            'menuHeader': function (val, oldVal) {
                console.log('顶栏菜单已改变：new: %s, old: %s', val, oldVal)
                this.menuHeaderMap = this.setMenuHeaderMap(val)
            }
        },
        methods: {
            getBreadcrumb() {
                /*let matched = this.$route.matched.filter(item => item.name)
                const first = matched[0]
                if (first && first.name !== 'index') {
                    matched = [{ path: '/index', meta: { title: '首页' }}].concat(matched)
                }
                this.levelList = matched*/
                let currentPath = this.$route.path
                if(this.excludePath.indexOf(currentPath)!=-1){
                    this.levelList = []
                }else{
                    let levelList = []
                    this.setLevelListPath(levelList,currentPath)
                    //增加首页链接
                    levelList.splice(0,0,'/index')
                    this.levelList = levelList
                }
            },
            setLevelListPath(levelList,path){
                levelList.splice(0,0,path)
                if(this.menuHeaderMap[path] && this.menuHeaderMap[path].parentPath){
                    this.setLevelListPath(levelList,this.menuHeaderMap[path].parentPath)
                }
            },
            setMenuHeaderMap(menuHeader,parentPath){
                let menuHeaderMap = {}
                for(let i in menuHeader){
                    menuHeaderMap[menuHeader[i].path] = {
                        'title': menuHeader[i].title,
                        'parentPath': parentPath
                    }
                    if(menuHeader[i].children){
                        menuHeaderMap = {...menuHeaderMap,...this.setMenuHeaderMap(menuHeader[i].children,menuHeader[i].path)}
                    }
                }
                return menuHeaderMap
            }
        }
    }
</script>

<style lang="scss">
    .app-breadcrumb{
        background: #ffffff;
        padding: 10px 20px;
        border: 1px solid #e8e7e7;
        border-width: 0 0 1px 0;

        .el-breadcrumb__inner a{
            //color: #66b1ff;
            font-weight: normal;
        }
    }
</style>
